import { useEffect, useRef } from "react";

export const useTouchControls = (
  onInputStart: (command: string) => void,
  onInputEnd: (command: string) => void
) => {
  const activeTouches = useRef(new Set<string>());

  const onTouchStart = (direction: "left" | "right") => {
    activeTouches.current.add(direction);
    onInputStart(direction);
  };

  const onTouchEnd = (direction: "left" | "right") => {
    if (activeTouches.current.has(direction)) {
      activeTouches.current.delete(direction);
      onInputEnd(direction);
    }
  };

  useEffect(() => {
    const cleanup = () => {
      // Clear all active touches when component blurs/unmounts
      activeTouches.current.forEach((direction) => {
        onInputEnd(direction);
      });
      activeTouches.current.clear();
    };

    window.addEventListener("blur", cleanup);
    return () => {
      cleanup();
      window.removeEventListener("blur", cleanup);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    onTouchStart,
    onTouchEnd,
  };
};
